export default "__VITE_ASSET__E_NP1kJ___"